import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Status, TimeStatus } from 'src/shared/models';
import { isSinConteo } from 'src/shared/utils';

@Component({
  selector: 'organism-card-cam',
  templateUrl: './card-cam.component.html',
  styleUrls: ['./card-cam.component.scss'],
})
export class CardCamComponent implements OnInit {
  @Input() cameraName: string = '';
  @Input() cameraId: number = 0;
  @Input() status: Status = Status.offline;
  @Input() timeStatus: TimeStatus = TimeStatus.ok;
  @Input() deviceName: string = '';
  @Input() ipAddress: string = '';
  @Input() lastDataSent: string = '';
  @Input() lastSync!: Date;
  @Input() sinConteo: string = '';
  @Input() ultimoConteo?: Date | string;
  @Input() iconType: 'arrow' | 'circle' | 'triangle' = 'arrow';
  public isTimeStatusVisible: boolean = false;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.isTimeStatusVisible = this.timeStatus && this.timeStatus !== TimeStatus.ok && this.timeStatus !== TimeStatus.desconocido;
  }

  get isSinConteo(): boolean {
    return isSinConteo(this.status, this.sinConteo, this.ultimoConteo);
  }

  get sinConteoHoras(): string {
    return `${this.sinConteo.split(':')[0]}h`;
  }

  get cardStatusClass(): string {
    if (this.isSinConteo) return 'sin-conteo';

    // Combina el status y timeStatus para determinar la clase CSS
    if (this.status && this.timeStatus) {
      return `${this.status}-${this.timeStatus}`;
    }

    return this.status; // Si no hay timeStatus, devuelve solo el status
  }

  getStatusIcon(): string {
    switch (this.status) {
      case 'online':
        return this.getOnlineIcon();
      case 'offline':
        return this.getOfflineIcon();
      default:
        return this.getOnlineIcon();
    }
  }

  private getOnlineIcon(): string {
    switch (this.iconType) {
      case 'arrow': return 'arrow_upward';
      case 'circle': return 'check_circle';
      default: return 'check_circle';
    }
  }

  private getOfflineIcon(): string {
    switch (this.iconType) {
      case 'arrow': return 'arrow_downward';
      case 'circle': return 'error';
      default: return 'error';
    }
  }
}
